import React from 'react';
import { FileSpreadsheetIcon } from 'lucide-react';
import { workbookSteps } from '../../data/site';
export function WorkbookLoop() {
  return <section id="workbooks" className="border-b border-line bg-cream" data-id="element-265" data-mp="3pbi6046972g2">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-266" data-mp="3bjtt3yo6k9y1">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16" data-id="element-267" data-mp="3fjvyoix1dnil">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-268" data-mp="742he1uvs80h">
            <p className="micro-label text-[9px] text-gold-600" data-id="element-269" data-mp="72hjc29cy6xv">Workbooks</p>
            <h2 className="mt-4 font-display text-[32px] font-semibold leading-[1.08] tracking-[-0.03em] text-charcoal-700 sm:text-[38px]" data-id="element-270" data-mp="c35bir9botto">
              Turn the 58-tab workbook into coordinated outcomes.
            </h2>
            <p className="mt-5 text-[15.5px] leading-relaxed text-charcoal-500" data-id="element-271" data-mp="353badxey57g">
              Implementation workbooks hold the knowledge needed to launch a system, complete a brand
              transition or open a department - but they are impossible to run as a living plan.
            </p>

            <div className="mt-8 flex items-start gap-3.5 border-t border-charcoal-700 pt-5" data-id="element-272" data-mp="lldciabqoxgi">
              <FileSpreadsheetIcon size={18} strokeWidth={1.9} className="mt-0.5 shrink-0 text-charcoal-400" aria-hidden="true" data-id="element-273" data-mp="gmahliph47m9" />
              <p className="text-[13.5px] leading-relaxed text-charcoal-500" data-id="element-274" data-mp="qkq9hnwbrkwt">
                Every task and question stays linked to its original sheet, cell and wording - so the
                file you hand back is the file the vendor asked for.
              </p>
            </div>
          </div>

          <ol className="space-y-0" data-id="element-275" data-mp="1e9sosp3hl1o5">
            {workbookSteps.map((step, index) => <li key={step} className="flex gap-5 border-b border-line py-5 first:border-t first:border-line" data-id="element-276" data-mp="19ay5lm1lxb3i" data-mpi={index}>
                <span className="font-display text-[13px] font-semibold tabular-nums text-gold-600" data-id="element-277" data-mp="1j82iev9kbu7n">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <p className="max-w-[62ch] text-[14.5px] leading-relaxed text-charcoal-600" data-id="element-278" data-mp="1v8st3nu98nqy">
                  {step}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}